var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"expenseModal",attrs:{"no-close-on-backdrop":true,"visible":_vm.showSubscribeModal,"id":"expenseModal"},on:{"hide":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }